import { createFileRoute } from "@tanstack/react-router";
import EssentialGuideToOcdSymptomsAndCarePage from "@/pages/articles/EssentialGuideToOcdSymptomsAndCarePage";
export const Route = createFileRoute(
  "/essential-guide-to-ocd-symptoms-and-care",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Essential Guide to OCD Symptoms and Care | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "A comprehensive guide to OCD symptoms, obsessions vs compulsions, evidence-based treatments including ERP, medication, and TMS therapy for resistant cases.",
        },
        {
          property: "og:title",
          content: "Essential Guide to OCD Symptoms and Care | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "A comprehensive guide to OCD symptoms, obsessions vs compulsions, evidence-based treatments including ERP, medication, and TMS therapy for resistant cases.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/essential-guide-to-ocd-symptoms-and-care",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/essential-guide-to-ocd-symptoms-and-care",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <EssentialGuideToOcdSymptomsAndCarePage />;
}
